angular.module('SpidApp')

.constant('CurrencyAdapterConfig', {
  name : 'Currency',
  fields : [
    {
    	local   : 'id',
    	distant : 'id'
    }, {
    	local   : 'label',
    	distant : 'label'
    }, {
    	local   : 'symbol',
    	distant : 'symbol'
    }, {
    	local   : 'rate',
    	distant : 'rate'
    }, {
    	local   : 'coins',
    	distant : 'coins'
    }, {
    	local   : 'bills',
    	distant : 'bills'
    }, {
    	local   : 'updated_at',
    	distant : 'updated_at'
    }
  ]
})
